/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ActorItem_actor = {
    readonly __typename: "User";
    readonly " $fragmentRefs": FragmentRefs<"UserItem_user">;
    readonly " $refType": "ActorItem_actor";
} | {
    readonly __typename: "Guild";
    readonly " $fragmentRefs": FragmentRefs<"GuildItem_guild">;
    readonly " $refType": "ActorItem_actor";
} | {
    /*This will never be '%other', but we need some
    value in case none of the concrete values match.*/
    readonly __typename: "%other";
    readonly " $refType": "ActorItem_actor";
};
export type ActorItem_actor$data = ActorItem_actor;
export type ActorItem_actor$key = {
    readonly " $data"?: ActorItem_actor$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ActorItem_actor">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "displayMyRelationStatus"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ActorItem_actor",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "displayFollowingMessage",
              "variableName": "displayMyRelationStatus"
            }
          ],
          "kind": "FragmentSpread",
          "name": "UserItem_user"
        }
      ],
      "type": "User",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "displayMembershipStatus",
              "variableName": "displayMyRelationStatus"
            }
          ],
          "kind": "FragmentSpread",
          "name": "GuildItem_guild"
        }
      ],
      "type": "Guild",
      "abstractKey": null
    }
  ],
  "type": "Actor",
  "abstractKey": "__isActor"
};
(node as any).hash = '2c218af16e90eac08caa013c532e8d33';
export default node;
